import React, {useState} from 'react'
import projectData from './projects.json'

export default function (props) {
    let project = projectData.projects;

    return {'react_obj': 'projects'}
}